<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import httpCommon from "./http-common";
import utilitiesMixin from "@/mixins/utilitiesMixin";
import jwtMixin from "@/mixins/jwtMixin.js";

export default {
  mixins: [jwtMixin, utilitiesMixin],
  name: "App",
  created() {
    let loader = null;
    let vueComponent = this;

    httpCommon.interceptors.request.use(
      (config) => {
        // CMM: En todas las peticiones se envía el token
        const token = vueComponent.$cookies.get("LTI_JWT");
        if (token != null) {
          config.headers.authorization = `Bearer ${token}`;
        }
        // CMM: Se muestra spinner de carga
        if (loader == null) {
          loader = this.$loading.show();
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    function hideLoader() {
      loader && loader.hide();
      loader = null;
    }
    function showError(error) {
      let response = error.response?.data;
      let message = response?.message;
      console.error({ error });

      if (message) {
        vueComponent.$noty.error(vueComponent.$t("noty.error.response-error"), {
          timeout: 5000,
          progressBar: true,
          closeWith: ["click"],
        });
      }
    }
    httpCommon.interceptors.response.use(
      (response) => {
        // hide loader
        hideLoader();
        return response;
      },
      (error) => {
        // hide loader
        hideLoader();
        showError(error);
        return Promise.reject(error);
      }
    );
  },
};
</script>
